<ion-header #myHeader id="myHeader" class="d-flex align-items-center justify-content-center">
  <!-- Application header container -->
  <ion-toolbar class="global-width ion-no-padding">
    <ion-grid class="ion-no-padding">
      <!-- Main header row handling layout alignment -->
      <ion-row class="w-100 align-items-center justify-content-between">
        <!-- Left section: menu trigger and application logo -->
        <ion-col class="d-flex align-items-center gap-2">
          <ion-buttons>
            <ion-menu-button>
              <ion-icon src="assets/icon/menu-outline.svg"></ion-icon>
            </ion-menu-button>
          </ion-buttons>

          <a class="logo-section d-inline-flex" [routerLink]="['/dashboard']" routerDirection="root"
            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <ion-img id=" appLogo" class="logo" src="assets/imgs/holman/inner-logo.png" alt="logo">
            </ion-img>
          </a>
        </ion-col>

        <!-- Right section: user details and action controls -->
        <ion-col class="d-flex align-items-center justify-content-end gap-2">
          <!-- Logged-in driver name display -->
          @if (driverData()) {
          <ion-text>
            <a class="welcome_txt position-relative text-decoration-none">
              {{ driverData()?.firstName ?? '-' }}
              {{ driverData()?.lastName ?? '-' }}
            </a>
          </ion-text>
          }

          <!-- Header action icons -->
          <div class="d-flex align-items-center position-relative">

            <!-- Notifications shortcut with unread count -->
            @if(showNotification){
            <ion-button fill="clear" class="ion-no-padding" [disabled]="disabled()"
              [ngClass]="disabled() ? 'header-action-disabled' : ''" (click)="goToNotification()"
              (keydown.enter)="goToNotification()">
              <ion-icon class="topMenuIcon" src="assets/imgs/notification-icon.svg">
              </ion-icon>
              <span class="noti-count">
                {{ unreadCount() }}
              </span>
            </ion-button>
            }

            <!-- My Data navigation shortcut -->
            <ion-button fill="clear" class="ion-no-padding m-link-hide" [disabled]="disabled()"
              [ngClass]="disabled() ? 'header-action-disabled' : ''" (click)="goToLink('my-profile')"
              (keydown.enter)="goToLink('my-profile')">
              <ion-icon class="topMenuIcon" src="assets/imgs/my-data-icon.svg">
              </ion-icon>
            </ion-button>

            <!-- Logout action -->
            <ion-button fill="clear" class="ion-no-padding m-link-hide" (click)="processLogout()"
              (keydown.enter)="processLogout()">
              <ion-icon class="topMenuIcon" src="assets/imgs/logout-topmenu-icon.svg">
              </ion-icon>
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-header>